// ! poradi a hodnoty musi byt stejne jako na serveru ! Pouziva se pro filtrovani v API
export const Partner = {
    Cebia: 0,
    SabServis: 1,
    Aaauto: 2,
    Davocar: 3,
    ChytryHonza: 4,
    Carvago: 5,
    UniCreditLeasing: 6,
    Allrisk: 7,
    AllianzKontakt: 8,
    LeasePlan: 9,
    LeasingCS: 10,
    RCI: 11,
    UCFM: 12,
    BMWFS: 13,
    MBFS: 14,
    RLCZ: 15,
    AndyAuto: 16,
    BusinessLease: 17,
    TUkas: 18,
    Essox: 19,
    AutoEsa: 20,
    DirectAuto: 21,
    Jap: 22,
    Kapitol: 23,
    Renomia: 24,
    OkGroup: 25,
    Respect: 26,
    VWFS: 27,
    UCLSK: 28,
    BMWFSSK: 29,
    MBFSSK: 30
}

export type Partner = typeof Partner[keyof typeof Partner]